/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ErrorPageModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { ERROR_PAGE_BODY_ITEM_TOKEN } from 'ajs/modules/error-page/error-page.tokens';

export type TErrorPageBodyCollection = typeof ErrorPageBodyCollection;

/**
 * @description ErrorPageBody collection class.
 *
 * @author Satish Pednekar
 */
export class ErrorPageBodyCollection extends Collection {
    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'errorpagebody',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_ERRORPAGEBODY,
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_(ERROR_PAGE_BODY_ITEM_TOKEN);
    }
}

ErrorPageBodyCollection.ajsDependencies = [
    ERROR_PAGE_BODY_ITEM_TOKEN,
];
